export function tickValue(value: number, index: number, values: number[]) {
  const resolution = values[values.length - 2] - values[values.length - 1];
  const resolutionsTimes = value / resolution;
  const shouldDisplay = Math.abs(Math.round(resolutionsTimes) - resolutionsTimes) < 0.0001;
  return shouldDisplay ? value : '';
}
